import SectionHeader from "./SectionHeader";
import { analysisFeatured, mechanisms } from "@/pages/home/data/analysis";

export default function Analysis() {
  return (
    <section id="analysis" className="bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="深度洞察"
          title="塌房心理学：粉丝为何在七十二小时内剧烈转向"
          description="脱粉、回踩与沉默不是冲动，而是一整套可解释的情感决策。编辑部用四个心理机制，把粉丝的反应拆给你看。"
        />

        {/* Featured article */}
        <article className="mt-10 grid grid-cols-1 items-stretch gap-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="relative h-full min-h-[240px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20psychology%20of%20parasocial%20relationships%2C%20floating%20thought%20bubbles%20and%20broken%20heart%20shapes%2C%20warm%20cream%20and%20amber%20tones%20with%20red%20accents%2C%20paper%20texture%2C%20stylized%20minimal%20vector%2C%20no%20people&width=900&height=640&seq=radar-analysis-01&orientation=landscape"
                alt="塌房后粉丝心理变化的抽象编辑插画"
                className="absolute inset-0 h-full w-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex flex-col p-6 md:p-8 lg:col-span-7">
            <div className="flex items-center gap-2 text-xs">
              <span className="rounded-full bg-accent-100 px-2.5 py-1 font-medium text-accent-800">
                {analysisFeatured.kicker}
              </span>
              <span className="text-foreground-500">编辑部专题</span>
            </div>
            <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {analysisFeatured.title}
            </h3>
            <p className="mt-3 font-heading text-[15px] font-semibold leading-relaxed text-primary-800">
              {analysisFeatured.deck}
            </p>
            <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-foreground-700">
              {analysisFeatured.body.map((para) => (
                <p key={para.slice(0, 8)}>{para}</p>
              ))}
            </div>
            <blockquote className="mt-5 border-l-2 border-secondary-400 bg-secondary-50 px-4 py-3 text-sm leading-relaxed text-secondary-900">
              {analysisFeatured.takeaway}
            </blockquote>
          </div>
        </article>

        {/* mechanisms */}
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {mechanisms.map((m) => (
            <article
              key={m.id}
              className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-700">
                  <i className={m.icon} aria-hidden="true"></i>
                </span>
                <h4 className="font-heading text-lg font-bold text-foreground-950">{m.title}</h4>
              </div>
              <p className="mt-3 font-medium text-[15px] leading-snug text-foreground-900">{m.lead}</p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{m.description}</p>
              <p className="mt-4 flex gap-2 text-[13px] leading-relaxed text-secondary-900">
                <i className="ri-question-line mt-0.5 shrink-0 text-secondary-600" aria-hidden="true"></i>
                {m.note}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}